// extracted by mini-css-extract-plugin
export default {"products":"mt-z","card":"nt-z","oosMessaging":"ot-z"};